/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { EntitySequence } from "./EntitySequence";
import { EntitySequenceFromJSON, EntitySequenceFromJSONTyped, EntitySequenceToJSON } from "./EntitySequence";
import type { SelectedColumns } from "./SelectedColumns";
import { SelectedColumnsFromJSON, SelectedColumnsFromJSONTyped, SelectedColumnsToJSON } from "./SelectedColumns";
import type { SequenceAlign } from "./SequenceAlign";
import { SequenceAlignFromJSON, SequenceAlignFromJSONTyped, SequenceAlignToJSON } from "./SequenceAlign";

/**
 *
 * @export
 * @interface SaveRequest
 */
export interface SaveRequest {
  /**
   *
   * @type {string}
   * @memberof SaveRequest
   */
  format?: string;
  /**
   *
   * @type {Array<EntitySequence>}
   * @memberof SaveRequest
   */
  entitySequences: Array<EntitySequence>;
  /**
   *
   * @type {Array<SequenceAlign>}
   * @memberof SaveRequest
   */
  alignedSequences: Array<SequenceAlign>;
  /**
   *
   * @type {SelectedColumns}
   * @memberof SaveRequest
   */
  selection?: SelectedColumns;
}

/**
 * Check if a given object implements the SaveRequest interface.
 */
export function instanceOfSaveRequest(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "entitySequences" in value;
  isInstance = isInstance && "alignedSequences" in value;

  return isInstance;
}

export function SaveRequestFromJSON(json: any): SaveRequest {
  return SaveRequestFromJSONTyped(json, false);
}

export function SaveRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveRequest {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    format: !exists(json, "format") ? undefined : json["format"],
    entitySequences: (json["entitySequences"] as Array<any>)?.map(EntitySequenceFromJSON),
    alignedSequences: (json["alignedSequences"] as Array<any>)?.map(SequenceAlignFromJSON),
    selection: !exists(json, "selection") ? undefined : SelectedColumnsFromJSON(json["selection"]),
  };
}

export function SaveRequestToJSON(value?: SaveRequest | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    format: value.format,
    entitySequences: (value.entitySequences as Array<any>)?.map(EntitySequenceToJSON),
    alignedSequences: (value.alignedSequences as Array<any>)?.map(SequenceAlignToJSON),
    selection: SelectedColumnsToJSON(value.selection),
  };
}
